// Конфигурация webhook URL для n8n (ячейка логина — PR51)

// База бэкенда — из сессии (redirect логина в другую ячейку), иначе GATSBY_N8N_BASE /
// прод NL. Источник один — getN8nBase() в app-host.js; URL строятся при КАЖДОМ чтении
// WEBHOOK_ENDPOINTS.X (геттеры), поэтому не кэшируйте их в константах модуля.
import { getN8nBase } from './app-host';

export const n8nBase = getN8nBase;

// Пути вебхуков; полный URL = n8nBase() + путь, см. геттеры ниже
export const WEBHOOK_PATHS = {
  replaceModel: '/webhook/replace-model',
  photoSession: '/webhook/photo-session',
  replaceBackground: '/webhook/replace-background',
  upscale: '/webhook/upscale',
  // KIE API endpoints
  KIE_PHOTOSESSION_CREATE: '/webhook/kie-photosession-create',
  KIE_REPLACE_MODEL_CREATE: '/webhook/kie-replace-model-create',
  KIE_INFOGRAPHIC_CREATE: '/webhook/kie-infographic-create',
  KIE_PHOTOTOVIDEO_CREATE: '/webhook/kie-phototovideo-create',
  KIE_PHOTOTOVIDEO_V2_CREATE: '/webhook/kie-phototovideo-v2-create',
  KIE_PHOTOGEN_CREATE: '/webhook/kie-photogen-create',
  KIE_SCENARIO_GENERATE: '/webhook/kie-scenario-generate',
  // Кредиты AI: баланс логина + прейскурант (только чтение, только роль client)
  AI_CREDITS: '/webhook/ai-credits',
  // Ассистент по данным (команда): action list/history/ask; ответ ask приходит строкой assistant_messages через history
  ASSISTANT: '/webhook/assistant',
  // Главная: дашборд по площадкам одним ответом (RPC home_dashboard, только команда)
  HOME_DASHBOARD: '/webhook/home-dashboard',
  // «Цена на сайте» (WB со СПП / Ozon с Ozon Картой): GET ?mp=wb|ozon&user_id&sku&days → { latest, daily }
  SITE_PRICES: '/webhook/site-prices',
  KIE_POLL: '/webhook/kie-poll',
  // Прокси-поллинг Segmind (ключ живёт в n8n-креденшле, не во фронте)
  SEGMIND_POLL: '/webhook/segmind-poll',
  // Photosession prompts editor (таблица photosession_prompts_gatsby)
  PHOTOSESSION_PROMPTS_LIST: '/webhook/photosession-prompts-list',
  PHOTOSESSION_PROMPTS_UPDATE: '/webhook/photosession-prompts-update',
  // AI Agent endpoints
  AI_AGENT_CHAT: '/webhook/ai-agent-chat', // старый webhook
  AI_AGENT_CHAT_V3: '/webhook/8f327cdd-0c3b-4072-a65f-0c3153e14abb', // новый Chat Trigger
  AI_AGENT_GENERATE_BATCH: '/webhook/ai-agent-generate-batch',
  // Tasks Queue endpoints
  TASKS_CREATE: '/webhook/tasks-create',
  TASKS_QUEUE_LIST: '/webhook/tasks-queue-list',
  // Authentication endpoint
  AUTH: '/webhook/auth-gatsby',
  // Server-side session check (app_users.session_version) — same n8n workflow
  AUTH_CHECK: '/webhook/auth-check',
  // Holiday Instagram endpoint
  HOLIDAY_INSTAGRAM: '/webhook/holiday-instagram',
  // Supplies report endpoint
  SUPPLIES_REPORT: '/webhook/report-supplies',
  // Честный знак (Marking) endpoints
  MARKING_CODES_STATS: '/webhook/marking-codes-stats',
  MARKING_GTIN_LOOKUP: '/webhook/marking-gtin-lookup',
  MARKING_CODES_AVAILABLE: '/webhook/marking-codes-available',
  MARKING_ORDERS_CREATE: '/webhook/marking-orders-create',
  MARKING_ORDERS_GET: '/webhook/marking-orders-get',
  MARKING_ORDERS_CONFIRM: '/webhook/marking-orders-confirm',
  MARKING_ORDERS_CANCEL: '/webhook/marking-orders-cancel',
  MARKING_ORDERS_LIST: '/webhook/marking-orders-list',
  MARKING_IMPORT: '/webhook/marking-import',
  // Вывод КИЗ из оборота (ЧЗ) по FBS-продажам из еженедельного отчёта WB
  CHZ_WITHDRAWAL_LIST: '/webhook/chz-withdrawal-list',
  CHZ_WITHDRAWAL_MARK: '/webhook/chz-withdrawal-mark',
  // Прокси в True API ЧЗ (подпись — в браузере, плагин КриптоПро)
  CHZ_API: '/webhook/chz-api',
  // УПД по маркировке → ЭДО Лайт (список из Notion, XML от WB, загрузка и подпись)
  UPD_API: '/webhook/upd-api',

  // Антифрод: кандидаты-подделки/чужие листинги под нашими фото (/antifraud, команда)
  ANTIFRAUD_API: '/webhook/af-api',
  // Настройки фирмы: ключи маркетплейсов, реквизиты, себестоимость, обмен 1С (/settings)
  FIRM_SETTINGS: '/webhook/firm-settings',
  // URL обмена, который клиент вписывает в 1С (показываем на /settings, сам обмен — отдельный воркфлоу)
  ONEC_EXCHANGE_APP: '/webhook/1c-exchange-app',
  // Проверка сборки FBS (сканер): passthrough в WB marketplace-api v3
  FBS_API: '/webhook/fbs-api',
  // QR поставок (/supply-qr — публичная страница без логина): узкий белый список операций
  // ЧТЕНИЯ вместо passthrough, писать в WB этот endpoint не умеет
  SUPPLY_QR_API: '/webhook/supply-qr-api',
  // Проверка сборки FBS Ozon: passthrough в Ozon Seller API + ветки positions/label
  OZON_FBS_API: '/webhook/ozon-fbs-api',
  // Ловец слотов FBW — наблюдения за слотами приёмки WB (watch_list/save/delete, warehouses)
  FBW_SLOTS_API: '/webhook/fbw-slots-api',
  // Видео FBS — события скана, поиск, клипы с камер (event/search/return_scan/clip/clip_status; agent_* — машина)
  FBS_VIDEO: '/webhook/fbs-video',
  // 1C CommerceML exchange endpoint
  COMMERCEML_EXCHANGE: '/webhook/1c-exchange',
  // Label A4 crop endpoint
  LABEL_A4_CROP: '/webhook/label-a4-crop',
  // A/B тестирование фото
  AB_CONTROL: '/webhook/ab-control',
  // Image Overlay — наложение логотипа и размеров на фото
  IMAGE_OVERLAY: '/webhook/image-overlay',
  // Weekly WB Financial Report
  WB_FINANCIAL_REPORT: '/webhook/wb-financial-report',
  // Product Card Analytics
  PRODUCT_CARD: '/webhook/product-card',
  // AI-анализ карточки: чтение кэша (?nmId= | карта по последней неделе) и ручной пересчёт
  AI_ANALYSIS_GET: '/webhook/ai-analysis-get',
  AI_ANALYSIS_RUN: '/webhook/ai-card-analysis-run',
  // AI-анализ финансового отчёта WB по фирме (еженедельно, кэш ai_fin_analysis)
  AI_FIN_ANALYSIS_GET: '/webhook/ai-fin-analysis-read',
  // то же для Ozon (кэш ai_ozon_fin_analysis, «AI Ozon Financial Analysis (multi)»)
  AI_OZON_FIN_ANALYSIS_GET: '/webhook/ai-ozon-fin-analysis-read',
  // Stocks Report (остатки по размерам)
  STOCKS_REPORT: '/webhook/stocks-report',
  // Excel поставки — объединение упаковочных листов и ШК коробов
  EXCEL_POSTAVKI: '/webhook/excel-postavki',
  // Поставка регион — критичное по регионам из рекомендаций
  SUPPLY_REGION: '/webhook/supply-region',
  // Поставка из 1С — «Заказ клиента» 1С → состав поставки Ozon / Excel для WB (команда)
  SUPPLY_FROM_1C: '/webhook/supply-from-1c',
  // Ловец слотов Ozon — наблюдения за таймслотами FBO (watch_*, clusters/dropoffs/products; команда)
  OZON_SLOTS_API: '/webhook/ozon-slots-api',
  // Репрайсер — данные таблицы, сохранение настроек, установка цен
  REPRICER_DATA: '/webhook/repricer-data',
  REPRICER_SAVE: '/webhook/repricer-save',
  REPRICER_APPLY: '/webhook/repricer-apply',
  REPRICER_PROMO_UPLOAD: '/webhook/repricer-promo-upload',
  // Ozon репрайсер — данные, настройки, применение цен, вход/выход из акций, ручной синк
  OZON_REPRICER_DATA: '/webhook/ozon-repricer-data',
  OZON_REPRICER_SAVE: '/webhook/ozon-repricer-save',
  OZON_REPRICER_APPLY: '/webhook/ozon-repricer-apply',
  OZON_REPRICER_PROMO: '/webhook/ozon-repricer-promo',
  OZON_REPRICER_SYNC: '/webhook/ozon-repricer-sync',
  // Ozon заказы — позиции/тепловая карта/разрез по фирмам (одним запросом)
  OZON_ORDERS_API: '/webhook/ozon-orders-api',
  // Ozon финотчёт — еженедельный отчёт и карточка товара по реальным начислениям (v_ozon_accrual_lines)
  OZON_FINANCIAL_REPORT: '/webhook/ozon-financial-report',
  OZON_PRODUCT_CARD: '/webhook/ozon-product-card',
  // Rich → Ozon (/ai-photo): товары фирмы, текущий rich, отправка картинок и статус задачи импорта
  OZON_RICH_PUSH: '/webhook/ozon-rich-push',
  // AI-анализ артикула Ozon (еженедельно, кэш ai_ozon_card_analysis): чтение (?key= | карта) и пересчёт
  AI_OZON_CARD_GET: '/webhook/ai-ozon-card-analysis-get',
  AI_OZON_CARD_RUN: '/webhook/ai-ozon-card-analysis-run',
  // Ozon «Покупатели» — отзывы и вопросы из кабинета (список, ответ, пропуск)
  OZON_COMM_API: '/webhook/ozon-comm-api',
  // Биддер — управление рекламными ставками (данные, настройки/правила, применение в WB)
  BIDDER_DATA: '/webhook/bidder-data',
  BIDDER_SAVE: '/webhook/bidder-save',
  BIDDER_APPLY: '/webhook/bidder-apply',
  // Уведомления (in-app notifications)
  NOTIFICATIONS_LIST: '/webhook/notifications-list',
  NOTIFICATIONS_UNREAD_COUNT: '/webhook/notifications-unread-count',
  NOTIFICATIONS_MARK_READ: '/webhook/notifications-mark-read',
  NOTIFICATIONS_MEASUREMENT_FIX: '/webhook/measurement-card-fix',
  // Финансы (iFinance) — загрузка CSV и отчёты (admin only)
  FINANCE_UPLOAD: '/webhook/finance-upload',
  FINANCE_REPORT: '/webhook/finance-report',
  FINANCE_SIMAN: '/webhook/finance-siman',
  FINANCE_SIMAN_PERIOD: '/webhook/finance-siman-period',
  // Общение с покупателями (возвраты/чаты/вопросы/отзывы)
  COMM_API: '/webhook/comm-api',
  COMM_CLAIMS_SYNC_RUN: '/webhook/comm-claims-sync-run',
  COMM_UNREAD_COUNT: '/webhook/comm-unread-count',
  COMM_CHAT_FILE: '/webhook/comm-chat-file',
  // Посещаемость — статистика из Notion «Календарь сотрудников» (manager/admin)
  ATTENDANCE: '/webhook/attendance',
  ATTENDANCE_NORM: '/webhook/attendance-norm',
  ATTENDANCE_LABEL: '/webhook/attendance-label',
  // Переработка/отгул из сводки табеля → таблица Notion «Зарплата <месяц> <год>».
  // Путь намеренно не под attendance*: тот префикс в исключениях nginx-гейта, а запись
  // в зарплату должна проходить проверку токена
  ATTENDANCE_SALARY_SYNC: '/webhook/salary-attendance-sync'
};

export const WEBHOOK_ENDPOINTS = {
  // Video merge endpoint (direct Python server) — не n8n, от ячейки не зависит
  VIDEO_MERGE: 'https://gatsby.kluchik.io/api/merge-videos',
};
Object.keys(WEBHOOK_PATHS).forEach((k) => {
  Object.defineProperty(WEBHOOK_ENDPOINTS, k, { get: () => n8nBase() + WEBHOOK_PATHS[k], enumerable: true });
});

// Конфигурация провайдеров для PhotoSession
export const PROVIDERS = {
  KIE: {
    name: 'KIE',
    createEndpoint: 'KIE_PHOTOSESSION_CREATE',
    pollEndpoint: 'KIE_POLL',
    requestFormat: 'kie', // для условной логики
  },
};

// Активный провайдер для PhotoSession
export const ACTIVE_PROVIDER = 'KIE';

// Для отладки
export const DEBUG_INFO = {
  environment: 'production',
  get webhookBase() { return n8nBase(); },
  endpoints: WEBHOOK_ENDPOINTS
};
